export default __webpack_public_path__ + "static/media/close-outlined.e7d2376a.svg";